import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { APPLICATION_ENDPOINTS } from '../constants/application-endpoints';

interface Captcha {
  siteKey: string;
}

export async function getCatpchaPublicKey(): Promise<string> {
  try {
    const response = await HttpService.get(APPLICATION_ENDPOINTS.GET_CAPTCHA_KEY_CONFIGURATION);
    const key = response.body as Captcha;
    return key.siteKey;
  } catch(error) {
    throw new Error('Failed to get captcha public key');
  }
}

